export default "mutation cartCreate {\n  cartCreate {\n    cart {\n      id\n    }\n    userErrors {\n      code\n      field\n      message\n    }\n  }\n}\n";